import Debug from 'debug';
import { ExamStateMachineAbstractState, ExamStateMachineCommonEvents } from './state'
import { ExamStateMachineData } from '../data'

const debug = Debug('exam-review-state')

interface Events extends ExamStateMachineCommonEvents {
  onReviewFinished: () => void
}

export class ExamReviewState extends ExamStateMachineAbstractState<Events> {

  public readonly name = 'review'

  constructor(
    private startAtQuestionIndex: number,
    private state: ExamStateMachineData) {
    super()
  }

  navigate(questionIndex: number) {
    this.state.updateCurrentQuestion(questionIndex, this.navigationOptions)
  }

  navigateNext() {
      this.state.goToNextQuestion(this.navigationOptions)
  }

  navigatePrevious() {
    this.state.goToPreviousQuestion(this.navigationOptions)
  }

  private get navigationOptions() {
    return { updateLastIndex: false }
  }

  finish() {
    this.triggerEvent(events => events.onReviewFinished())
  }

  enter() {
    debug('enter')
    this.state.review(this.startAtQuestionIndex, { updateLastIndex: false })
  }

  exit() {
    debug('exit')
  }

  cancel() {
    debug('cancel')
    this.beginCancel()
    this.endCancel()
  }
}
